<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <b-button variant="success" class="text-white" :disabled="exporting" v-on:click="exportGrid()"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar</b-button>
    </div>
    <Grid name="historyGrid" ref="historyGrid" :editable="true" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import States from '@/components/Lists.js'

export default {
  name: 'ActivitiesGrid',
  components: {
    Grid
  },
  data() {
    return {
      exporting: false,
      fileDownload: {
        url: '',
        title: ''
      },
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        },
        activity_id: {
          type: 'number',
          editable: true
        },
        state: {
          type: 'number',
          editable: true
        },
        family_member_id: {
          type: 'number',
          editable: false
        },
        activity_year_id: {
          type: 'number',
          editable: false
        },
        activity_year: {
          type: 'number',
          editable: false
        },
        'compound_key': {
          type: 'text',
          editable: false
        },
        'participant_name': {
          type: 'text',
          editable: false
        }

      },
      url: 'history',
      preload: [{
        api: 'activities/lst',
        field: 'activity_id'
      }],
      columns: [{
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      },
      {
        field: 'activity_id',
        title: 'Actividade',
        width: '180px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '180px',
        values: States.historyStates
      },
      {
        field: 'activity_year',
        title: 'Ano',
        width: '180px',
        editable: false
      },
      {
        field: 'family_member_id',
        title: 'Id Participante',
        width: '180px',
        editable: false
      },
      {
        field: 'compound_key',
        title: 'Chave Participante',
        width: '180px',
        editable: false
      },
      {
        field: 'participant_name',
        title: 'Participante',
        width: '180px',
        filterable: false
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    getBtnTemplate: function(item) {
      if (this.$auth.check('history.edit')) {
        var route = router.resolve({
          name: 'history.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('history.view')) {
        var route = router.resolve({
          name: 'history.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.historyGrid.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post('history/export', {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
  }
}
</script>
